import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { StockExtended, StoreFunctionsApi } from "apis/StoreFunctionsApi";
import { StoreResponse, InternalResponse } from "models/common/responseObjects";
import { StockSearchFunction } from "models/functionModels/stockFunctions/StockSearchFunction";

export const getStoreStocks = createAsyncThunk("storeStocksSlice/getStoreStocks", async (id: string) => {
    const response = await StoreFunctionsApi.StockSearchHistory({ id: id });
    return response.data.stores;
});

export const storeStockSearch = createAsyncThunk("storeStocksSlice/storeStockSearch", async (params: StockSearchFunction) => {
    const response = await StoreFunctionsApi.StockSearch(params);
    return response.data.stores;
});

type StoreStockTableData = StockExtended & {
    storeName: string;
};

type InitialStateType = {
    storeId: number;
    storeStockTable: StoreStockTableData[];
    storeName: string;
    name: string;
    shopSOH: number;
    costEx: number;
    gp: number;
    sellPrice: number;
    sellPriceEx: number;
    purchaseHistory: any[];
    salesHistory: any[];
    table: any[],
};


const initialState : InitialStateType = {
    storeId: 0,
    storeStockTable: [],
    storeName: "",
    name: "",
    shopSOH: 0,
    costEx: 0,
    gp: 0,
    sellPrice: 0,
    sellPriceEx: 0,
    purchaseHistory: [
        {
            qty: 0
        },
        {
            qty: 0
        },
        {
            qty: 0.0
        },
        {
            qty: 0.0
        },
        {
            qty: 0.0
        },
        {
            qty: 0.0
        },
        {
            qty: 0.0
        },
        { 
            qty: 0.0
        },
        {
            qty: 0.0
        },
        {
            qty: 0.0
        },
        {
            qty: 0.0
        },
        {
            qty: 0.0
        },
    ],
    salesHistory: [{
        qty: 0
    },
    {
        qty: 0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },
    {
        qty: 0.0
    },],

    table: []
};

const storeStocksSlice = createSlice({
    name: "storeStocksSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        cleanStoreStocksDetails: (state) => {
            return {
                ...state,
                ...initialState,
            }
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getStoreStocks.fulfilled, (state, action) => {
            state.table = action.payload.map((stores) => {

                let retValue = {
                    storeInitialName: stores.storeName,
                    ...stores,
                    purchaseHistory: initialState.purchaseHistory,
                    salesHistory: initialState.salesHistory,
                };

                return {
                    ...retValue,
                    ...stores.response,
                }
            }).map((stores: any) => {
                delete stores.response;
                return stores;
            });

        });

        builder.addCase(storeStockSearch.pending, (state, action) => {
            state.storeStockTable = [];
        });

        builder.addCase(storeStockSearch.rejected, (state, action) => {
            state.storeStockTable = [];
        });

        builder.addCase(storeStockSearch.fulfilled, (state, action) => {
            state.storeStockTable = action.payload.flatMap(i => i.response?.data.map(x => ({...x, storeName: i.storeName})) ?? []) || [];
        });
    }
});

export const { cleanStoreStocksDetails } = storeStocksSlice.actions;

export default storeStocksSlice.reducer;